/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as CalendarRouteImport } from './routes/calendar'
import { Route as GalleryRouteImport } from './routes/gallery'
import { Route as IngredientsRouteImport } from './routes/ingredients'
import { Route as InsightsRouteImport } from './routes/insights'
import { Route as InventoryRouteImport } from './routes/inventory'
import { Route as ListingsRouteImport } from './routes/listings'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SigninRouteImport } from './routes/signin'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminBillingRouteImport } from './routes/admin/billing'
import { Route as AdminBoardRouteImport } from './routes/admin/board'
import { Route as AdminGalleryRouteImport } from './routes/admin/gallery'
import { Route as AdminHealthRouteImport } from './routes/admin/health'
import { Route as AdminSupportRouteImport } from './routes/admin/support'
import { Route as AdminUsageRouteImport } from './routes/admin/usage'
import { Route as BatchesIndexRouteImport } from './routes/batches/index'
import { Route as BatchesLabelsRouteImport } from './routes/batches/labels'
import { Route as BatchesTastingCardsRouteImport } from './routes/batches/tasting-cards'
import { Route as BlendingIndexRouteImport } from './routes/blending/index'
import { Route as GEntryIdRouteImport } from './routes/g/$entryId'
import { Route as InviteTokenRouteImport } from './routes/invite/$token'
import { Route as JTokenRouteImport } from './routes/j/$token'
import { Route as JournalsIndexRouteImport } from './routes/journals/index'
import { Route as ProfilesIndexRouteImport } from './routes/profiles/index'
import { Route as ProfilesTabRouteImport } from './routes/profiles/$tab'
import { Route as RecipesIndexRouteImport } from './routes/recipes/index'
import { Route as RecipesNewRouteImport } from './routes/recipes/new'
import { Route as STokenRouteImport } from './routes/s/$token'
import { Route as SupportIndexRouteImport } from './routes/support/index'
import { Route as SupportTabRouteImport } from './routes/support/$tab'
import { Route as TTokenRouteImport } from './routes/t/$token'
import { Route as AdminUsersIndexRouteImport } from './routes/admin/users/index'
import { Route as AdminUsersUserIdRouteImport } from './routes/admin/users/$userId'
import { Route as BatchesBatchIdIndexRouteImport } from './routes/batches/$batchId/index'
import { Route as BatchesBatchIdBrewRouteImport } from './routes/batches/$batchId/brew'
import { Route as BatchesBatchIdFeedbackRouteImport } from './routes/batches/$batchId/feedback'
import { Route as BatchesBatchIdSheetRouteImport } from './routes/batches/$batchId/sheet'
import { Route as BlendingBlendIdIndexRouteImport } from './routes/blending/$blendId/index'
import { Route as BlendingBlendIdFeedbackRouteImport } from './routes/blending/$blendId/feedback'
import { Route as JournalsJournalIdIndexRouteImport } from './routes/journals/$journalId/index'
import { Route as JournalsJournalIdFeedbackRouteImport } from './routes/journals/$journalId/feedback'
import { Route as RecipesRecipeIdIndexRouteImport } from './routes/recipes/$recipeId/index'
import { Route as RecipesRecipeIdSheetRouteImport } from './routes/recipes/$recipeId/sheet'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const CalendarRoute = CalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => rootRouteImport,
} as any)
const GalleryRoute = GalleryRouteImport.update({
  id: '/gallery',
  path: '/gallery',
  getParentRoute: () => rootRouteImport,
} as any)
const IngredientsRoute = IngredientsRouteImport.update({
  id: '/ingredients',
  path: '/ingredients',
  getParentRoute: () => rootRouteImport,
} as any)
const InsightsRoute = InsightsRouteImport.update({
  id: '/insights',
  path: '/insights',
  getParentRoute: () => rootRouteImport,
} as any)
const InventoryRoute = InventoryRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => rootRouteImport,
} as any)
const ListingsRoute = ListingsRouteImport.update({
  id: '/listings',
  path: '/listings',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SigninRoute = SigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminBillingRoute = AdminBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminBoardRoute = AdminBoardRouteImport.update({
  id: '/board',
  path: '/board',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminGalleryRoute = AdminGalleryRouteImport.update({
  id: '/gallery',
  path: '/gallery',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminHealthRoute = AdminHealthRouteImport.update({
  id: '/health',
  path: '/health',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminSupportRoute = AdminSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminUsageRoute = AdminUsageRouteImport.update({
  id: '/usage',
  path: '/usage',
  getParentRoute: () => AdminRouteRoute,
} as any)
const BatchesIndexRoute = BatchesIndexRouteImport.update({
  id: '/batches/',
  path: '/batches/',
  getParentRoute: () => rootRouteImport,
} as any)
const BatchesLabelsRoute = BatchesLabelsRouteImport.update({
  id: '/batches/labels',
  path: '/batches/labels',
  getParentRoute: () => rootRouteImport,
} as any)
const BatchesTastingCardsRoute = BatchesTastingCardsRouteImport.update({
  id: '/batches/tasting-cards',
  path: '/batches/tasting-cards',
  getParentRoute: () => rootRouteImport,
} as any)
const BlendingIndexRoute = BlendingIndexRouteImport.update({
  id: '/blending/',
  path: '/blending/',
  getParentRoute: () => rootRouteImport,
} as any)
const GEntryIdRoute = GEntryIdRouteImport.update({
  id: '/g/$entryId',
  path: '/g/$entryId',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const JTokenRoute = JTokenRouteImport.update({
  id: '/j/$token',
  path: '/j/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const JournalsIndexRoute = JournalsIndexRouteImport.update({
  id: '/journals/',
  path: '/journals/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfilesIndexRoute = ProfilesIndexRouteImport.update({
  id: '/profiles/',
  path: '/profiles/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfilesTabRoute = ProfilesTabRouteImport.update({
  id: '/profiles/$tab',
  path: '/profiles/$tab',
  getParentRoute: () => rootRouteImport,
} as any)
const RecipesIndexRoute = RecipesIndexRouteImport.update({
  id: '/recipes/',
  path: '/recipes/',
  getParentRoute: () => rootRouteImport,
} as any)
const RecipesNewRoute = RecipesNewRouteImport.update({
  id: '/recipes/new',
  path: '/recipes/new',
  getParentRoute: () => rootRouteImport,
} as any)
const STokenRoute = STokenRouteImport.update({
  id: '/s/$token',
  path: '/s/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportIndexRoute = SupportIndexRouteImport.update({
  id: '/support/',
  path: '/support/',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportTabRoute = SupportTabRouteImport.update({
  id: '/support/$tab',
  path: '/support/$tab',
  getParentRoute: () => rootRouteImport,
} as any)
const TTokenRoute = TTokenRouteImport.update({
  id: '/t/$token',
  path: '/t/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersIndexRoute = AdminUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminUsersUserIdRoute = AdminUsersUserIdRouteImport.update({
  id: '/users/$userId',
  path: '/users/$userId',
  getParentRoute: () => AdminRouteRoute,
} as any)
const BatchesBatchIdIndexRoute = BatchesBatchIdIndexRouteImport.update({
  id: '/batches/$batchId/',
  path: '/batches/$batchId/',
  getParentRoute: () => rootRouteImport,
} as any)
const BatchesBatchIdBrewRoute = BatchesBatchIdBrewRouteImport.update({
  id: '/batches/$batchId/brew',
  path: '/batches/$batchId/brew',
  getParentRoute: () => rootRouteImport,
} as any)
const BatchesBatchIdFeedbackRoute = BatchesBatchIdFeedbackRouteImport.update({
  id: '/batches/$batchId/feedback',
  path: '/batches/$batchId/feedback',
  getParentRoute: () => rootRouteImport,
} as any)
const BatchesBatchIdSheetRoute = BatchesBatchIdSheetRouteImport.update({
  id: '/batches/$batchId/sheet',
  path: '/batches/$batchId/sheet',
  getParentRoute: () => rootRouteImport,
} as any)
const BlendingBlendIdIndexRoute = BlendingBlendIdIndexRouteImport.update({
  id: '/blending/$blendId/',
  path: '/blending/$blendId/',
  getParentRoute: () => rootRouteImport,
} as any)
const BlendingBlendIdFeedbackRoute = BlendingBlendIdFeedbackRouteImport.update({
  id: '/blending/$blendId/feedback',
  path: '/blending/$blendId/feedback',
  getParentRoute: () => rootRouteImport,
} as any)
const JournalsJournalIdIndexRoute = JournalsJournalIdIndexRouteImport.update({
  id: '/journals/$journalId/',
  path: '/journals/$journalId/',
  getParentRoute: () => rootRouteImport,
} as any)
const JournalsJournalIdFeedbackRoute =
  JournalsJournalIdFeedbackRouteImport.update({
    id: '/journals/$journalId/feedback',
    path: '/journals/$journalId/feedback',
    getParentRoute: () => rootRouteImport,
  } as any)
const RecipesRecipeIdIndexRoute = RecipesRecipeIdIndexRouteImport.update({
  id: '/recipes/$recipeId/',
  path: '/recipes/$recipeId/',
  getParentRoute: () => rootRouteImport,
} as any)
const RecipesRecipeIdSheetRoute = RecipesRecipeIdSheetRouteImport.update({
  id: '/recipes/$recipeId/sheet',
  path: '/recipes/$recipeId/sheet',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/calendar': typeof CalendarRoute
  '/gallery': typeof GalleryRoute
  '/ingredients': typeof IngredientsRoute
  '/insights': typeof InsightsRoute
  '/inventory': typeof InventoryRoute
  '/listings': typeof ListingsRoute
  '/settings': typeof SettingsRoute
  '/signin': typeof SigninRoute
  '/admin/billing': typeof AdminBillingRoute
  '/admin/board': typeof AdminBoardRoute
  '/admin/gallery': typeof AdminGalleryRoute
  '/admin/health': typeof AdminHealthRoute
  '/admin/support': typeof AdminSupportRoute
  '/admin/usage': typeof AdminUsageRoute
  '/batches/labels': typeof BatchesLabelsRoute
  '/batches/tasting-cards': typeof BatchesTastingCardsRoute
  '/g/$entryId': typeof GEntryIdRoute
  '/invite/$token': typeof InviteTokenRoute
  '/j/$token': typeof JTokenRoute
  '/profiles/$tab': typeof ProfilesTabRoute
  '/recipes/new': typeof RecipesNewRoute
  '/s/$token': typeof STokenRoute
  '/support/$tab': typeof SupportTabRoute
  '/t/$token': typeof TTokenRoute
  '/admin/': typeof AdminIndexRoute
  '/batches/': typeof BatchesIndexRoute
  '/blending/': typeof BlendingIndexRoute
  '/journals/': typeof JournalsIndexRoute
  '/profiles/': typeof ProfilesIndexRoute
  '/recipes/': typeof RecipesIndexRoute
  '/support/': typeof SupportIndexRoute
  '/admin/users/$userId': typeof AdminUsersUserIdRoute
  '/batches/$batchId/brew': typeof BatchesBatchIdBrewRoute
  '/batches/$batchId/feedback': typeof BatchesBatchIdFeedbackRoute
  '/batches/$batchId/sheet': typeof BatchesBatchIdSheetRoute
  '/blending/$blendId/feedback': typeof BlendingBlendIdFeedbackRoute
  '/journals/$journalId/feedback': typeof JournalsJournalIdFeedbackRoute
  '/recipes/$recipeId/sheet': typeof RecipesRecipeIdSheetRoute
  '/admin/users/': typeof AdminUsersIndexRoute
  '/batches/$batchId/': typeof BatchesBatchIdIndexRoute
  '/blending/$blendId/': typeof BlendingBlendIdIndexRoute
  '/journals/$journalId/': typeof JournalsJournalIdIndexRoute
  '/recipes/$recipeId/': typeof RecipesRecipeIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/calendar': typeof CalendarRoute
  '/gallery': typeof GalleryRoute
  '/ingredients': typeof IngredientsRoute
  '/insights': typeof InsightsRoute
  '/inventory': typeof InventoryRoute
  '/listings': typeof ListingsRoute
  '/settings': typeof SettingsRoute
  '/signin': typeof SigninRoute
  '/admin/billing': typeof AdminBillingRoute
  '/admin/board': typeof AdminBoardRoute
  '/admin/gallery': typeof AdminGalleryRoute
  '/admin/health': typeof AdminHealthRoute
  '/admin/support': typeof AdminSupportRoute
  '/admin/usage': typeof AdminUsageRoute
  '/batches/labels': typeof BatchesLabelsRoute
  '/batches/tasting-cards': typeof BatchesTastingCardsRoute
  '/g/$entryId': typeof GEntryIdRoute
  '/invite/$token': typeof InviteTokenRoute
  '/j/$token': typeof JTokenRoute
  '/profiles/$tab': typeof ProfilesTabRoute
  '/recipes/new': typeof RecipesNewRoute
  '/s/$token': typeof STokenRoute
  '/support/$tab': typeof SupportTabRoute
  '/t/$token': typeof TTokenRoute
  '/admin': typeof AdminIndexRoute
  '/batches': typeof BatchesIndexRoute
  '/blending': typeof BlendingIndexRoute
  '/journals': typeof JournalsIndexRoute
  '/profiles': typeof ProfilesIndexRoute
  '/recipes': typeof RecipesIndexRoute
  '/support': typeof SupportIndexRoute
  '/admin/users/$userId': typeof AdminUsersUserIdRoute
  '/batches/$batchId/brew': typeof BatchesBatchIdBrewRoute
  '/batches/$batchId/feedback': typeof BatchesBatchIdFeedbackRoute
  '/batches/$batchId/sheet': typeof BatchesBatchIdSheetRoute
  '/blending/$blendId/feedback': typeof BlendingBlendIdFeedbackRoute
  '/journals/$journalId/feedback': typeof JournalsJournalIdFeedbackRoute
  '/recipes/$recipeId/sheet': typeof RecipesRecipeIdSheetRoute
  '/admin/users': typeof AdminUsersIndexRoute
  '/batches/$batchId': typeof BatchesBatchIdIndexRoute
  '/blending/$blendId': typeof BlendingBlendIdIndexRoute
  '/journals/$journalId': typeof JournalsJournalIdIndexRoute
  '/recipes/$recipeId': typeof RecipesRecipeIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/calendar': typeof CalendarRoute
  '/gallery': typeof GalleryRoute
  '/ingredients': typeof IngredientsRoute
  '/insights': typeof InsightsRoute
  '/inventory': typeof InventoryRoute
  '/listings': typeof ListingsRoute
  '/settings': typeof SettingsRoute
  '/signin': typeof SigninRoute
  '/admin/billing': typeof AdminBillingRoute
  '/admin/board': typeof AdminBoardRoute
  '/admin/gallery': typeof AdminGalleryRoute
  '/admin/health': typeof AdminHealthRoute
  '/admin/support': typeof AdminSupportRoute
  '/admin/usage': typeof AdminUsageRoute
  '/batches/labels': typeof BatchesLabelsRoute
  '/batches/tasting-cards': typeof BatchesTastingCardsRoute
  '/g/$entryId': typeof GEntryIdRoute
  '/invite/$token': typeof InviteTokenRoute
  '/j/$token': typeof JTokenRoute
  '/profiles/$tab': typeof ProfilesTabRoute
  '/recipes/new': typeof RecipesNewRoute
  '/s/$token': typeof STokenRoute
  '/support/$tab': typeof SupportTabRoute
  '/t/$token': typeof TTokenRoute
  '/admin/': typeof AdminIndexRoute
  '/batches/': typeof BatchesIndexRoute
  '/blending/': typeof BlendingIndexRoute
  '/journals/': typeof JournalsIndexRoute
  '/profiles/': typeof ProfilesIndexRoute
  '/recipes/': typeof RecipesIndexRoute
  '/support/': typeof SupportIndexRoute
  '/admin/users/$userId': typeof AdminUsersUserIdRoute
  '/batches/$batchId/brew': typeof BatchesBatchIdBrewRoute
  '/batches/$batchId/feedback': typeof BatchesBatchIdFeedbackRoute
  '/batches/$batchId/sheet': typeof BatchesBatchIdSheetRoute
  '/blending/$blendId/feedback': typeof BlendingBlendIdFeedbackRoute
  '/journals/$journalId/feedback': typeof JournalsJournalIdFeedbackRoute
  '/recipes/$recipeId/sheet': typeof RecipesRecipeIdSheetRoute
  '/admin/users/': typeof AdminUsersIndexRoute
  '/batches/$batchId/': typeof BatchesBatchIdIndexRoute
  '/blending/$blendId/': typeof BlendingBlendIdIndexRoute
  '/journals/$journalId/': typeof JournalsJournalIdIndexRoute
  '/recipes/$recipeId/': typeof RecipesRecipeIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/calendar'
    | '/gallery'
    | '/ingredients'
    | '/insights'
    | '/inventory'
    | '/listings'
    | '/settings'
    | '/signin'
    | '/admin/billing'
    | '/admin/board'
    | '/admin/gallery'
    | '/admin/health'
    | '/admin/support'
    | '/admin/usage'
    | '/batches/labels'
    | '/batches/tasting-cards'
    | '/g/$entryId'
    | '/invite/$token'
    | '/j/$token'
    | '/profiles/$tab'
    | '/recipes/new'
    | '/s/$token'
    | '/support/$tab'
    | '/t/$token'
    | '/admin/'
    | '/batches/'
    | '/blending/'
    | '/journals/'
    | '/profiles/'
    | '/recipes/'
    | '/support/'
    | '/admin/users/$userId'
    | '/batches/$batchId/brew'
    | '/batches/$batchId/feedback'
    | '/batches/$batchId/sheet'
    | '/blending/$blendId/feedback'
    | '/journals/$journalId/feedback'
    | '/recipes/$recipeId/sheet'
    | '/admin/users/'
    | '/batches/$batchId/'
    | '/blending/$blendId/'
    | '/journals/$journalId/'
    | '/recipes/$recipeId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/calendar'
    | '/gallery'
    | '/ingredients'
    | '/insights'
    | '/inventory'
    | '/listings'
    | '/settings'
    | '/signin'
    | '/admin/billing'
    | '/admin/board'
    | '/admin/gallery'
    | '/admin/health'
    | '/admin/support'
    | '/admin/usage'
    | '/batches/labels'
    | '/batches/tasting-cards'
    | '/g/$entryId'
    | '/invite/$token'
    | '/j/$token'
    | '/profiles/$tab'
    | '/recipes/new'
    | '/s/$token'
    | '/support/$tab'
    | '/t/$token'
    | '/admin'
    | '/batches'
    | '/blending'
    | '/journals'
    | '/profiles'
    | '/recipes'
    | '/support'
    | '/admin/users/$userId'
    | '/batches/$batchId/brew'
    | '/batches/$batchId/feedback'
    | '/batches/$batchId/sheet'
    | '/blending/$blendId/feedback'
    | '/journals/$journalId/feedback'
    | '/recipes/$recipeId/sheet'
    | '/admin/users'
    | '/batches/$batchId'
    | '/blending/$blendId'
    | '/journals/$journalId'
    | '/recipes/$recipeId'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/calendar'
    | '/gallery'
    | '/ingredients'
    | '/insights'
    | '/inventory'
    | '/listings'
    | '/settings'
    | '/signin'
    | '/admin/billing'
    | '/admin/board'
    | '/admin/gallery'
    | '/admin/health'
    | '/admin/support'
    | '/admin/usage'
    | '/batches/labels'
    | '/batches/tasting-cards'
    | '/g/$entryId'
    | '/invite/$token'
    | '/j/$token'
    | '/profiles/$tab'
    | '/recipes/new'
    | '/s/$token'
    | '/support/$tab'
    | '/t/$token'
    | '/admin/'
    | '/batches/'
    | '/blending/'
    | '/journals/'
    | '/profiles/'
    | '/recipes/'
    | '/support/'
    | '/admin/users/$userId'
    | '/batches/$batchId/brew'
    | '/batches/$batchId/feedback'
    | '/batches/$batchId/sheet'
    | '/blending/$blendId/feedback'
    | '/journals/$journalId/feedback'
    | '/recipes/$recipeId/sheet'
    | '/admin/users/'
    | '/batches/$batchId/'
    | '/blending/$blendId/'
    | '/journals/$journalId/'
    | '/recipes/$recipeId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  CalendarRoute: typeof CalendarRoute
  GalleryRoute: typeof GalleryRoute
  IngredientsRoute: typeof IngredientsRoute
  InsightsRoute: typeof InsightsRoute
  InventoryRoute: typeof InventoryRoute
  ListingsRoute: typeof ListingsRoute
  SettingsRoute: typeof SettingsRoute
  SigninRoute: typeof SigninRoute
  BatchesLabelsRoute: typeof BatchesLabelsRoute
  BatchesTastingCardsRoute: typeof BatchesTastingCardsRoute
  GEntryIdRoute: typeof GEntryIdRoute
  InviteTokenRoute: typeof InviteTokenRoute
  JTokenRoute: typeof JTokenRoute
  ProfilesTabRoute: typeof ProfilesTabRoute
  RecipesNewRoute: typeof RecipesNewRoute
  STokenRoute: typeof STokenRoute
  SupportTabRoute: typeof SupportTabRoute
  TTokenRoute: typeof TTokenRoute
  BatchesIndexRoute: typeof BatchesIndexRoute
  BlendingIndexRoute: typeof BlendingIndexRoute
  JournalsIndexRoute: typeof JournalsIndexRoute
  ProfilesIndexRoute: typeof ProfilesIndexRoute
  RecipesIndexRoute: typeof RecipesIndexRoute
  SupportIndexRoute: typeof SupportIndexRoute
  BatchesBatchIdBrewRoute: typeof BatchesBatchIdBrewRoute
  BatchesBatchIdFeedbackRoute: typeof BatchesBatchIdFeedbackRoute
  BatchesBatchIdSheetRoute: typeof BatchesBatchIdSheetRoute
  BlendingBlendIdFeedbackRoute: typeof BlendingBlendIdFeedbackRoute
  JournalsJournalIdFeedbackRoute: typeof JournalsJournalIdFeedbackRoute
  RecipesRecipeIdSheetRoute: typeof RecipesRecipeIdSheetRoute
  BatchesBatchIdIndexRoute: typeof BatchesBatchIdIndexRoute
  BlendingBlendIdIndexRoute: typeof BlendingBlendIdIndexRoute
  JournalsJournalIdIndexRoute: typeof JournalsJournalIdIndexRoute
  RecipesRecipeIdIndexRoute: typeof RecipesRecipeIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calendar': {
      id: '/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof CalendarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gallery': {
      id: '/gallery'
      path: '/gallery'
      fullPath: '/gallery'
      preLoaderRoute: typeof GalleryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ingredients': {
      id: '/ingredients'
      path: '/ingredients'
      fullPath: '/ingredients'
      preLoaderRoute: typeof IngredientsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/insights': {
      id: '/insights'
      path: '/insights'
      fullPath: '/insights'
      preLoaderRoute: typeof InsightsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventory': {
      id: '/inventory'
      path: '/inventory'
      fullPath: '/inventory'
      preLoaderRoute: typeof InventoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/listings': {
      id: '/listings'
      path: '/listings'
      fullPath: '/listings'
      preLoaderRoute: typeof ListingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signin': {
      id: '/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof SigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/billing': {
      id: '/admin/billing'
      path: '/billing'
      fullPath: '/admin/billing'
      preLoaderRoute: typeof AdminBillingRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/board': {
      id: '/admin/board'
      path: '/board'
      fullPath: '/admin/board'
      preLoaderRoute: typeof AdminBoardRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/gallery': {
      id: '/admin/gallery'
      path: '/gallery'
      fullPath: '/admin/gallery'
      preLoaderRoute: typeof AdminGalleryRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/health': {
      id: '/admin/health'
      path: '/health'
      fullPath: '/admin/health'
      preLoaderRoute: typeof AdminHealthRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/support': {
      id: '/admin/support'
      path: '/support'
      fullPath: '/admin/support'
      preLoaderRoute: typeof AdminSupportRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/usage': {
      id: '/admin/usage'
      path: '/usage'
      fullPath: '/admin/usage'
      preLoaderRoute: typeof AdminUsageRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/batches/': {
      id: '/batches/'
      path: '/batches'
      fullPath: '/batches/'
      preLoaderRoute: typeof BatchesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/batches/labels': {
      id: '/batches/labels'
      path: '/batches/labels'
      fullPath: '/batches/labels'
      preLoaderRoute: typeof BatchesLabelsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/batches/tasting-cards': {
      id: '/batches/tasting-cards'
      path: '/batches/tasting-cards'
      fullPath: '/batches/tasting-cards'
      preLoaderRoute: typeof BatchesTastingCardsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blending/': {
      id: '/blending/'
      path: '/blending'
      fullPath: '/blending/'
      preLoaderRoute: typeof BlendingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/g/$entryId': {
      id: '/g/$entryId'
      path: '/g/$entryId'
      fullPath: '/g/$entryId'
      preLoaderRoute: typeof GEntryIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/j/$token': {
      id: '/j/$token'
      path: '/j/$token'
      fullPath: '/j/$token'
      preLoaderRoute: typeof JTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/journals/': {
      id: '/journals/'
      path: '/journals'
      fullPath: '/journals/'
      preLoaderRoute: typeof JournalsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profiles/': {
      id: '/profiles/'
      path: '/profiles'
      fullPath: '/profiles/'
      preLoaderRoute: typeof ProfilesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profiles/$tab': {
      id: '/profiles/$tab'
      path: '/profiles/$tab'
      fullPath: '/profiles/$tab'
      preLoaderRoute: typeof ProfilesTabRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recipes/': {
      id: '/recipes/'
      path: '/recipes'
      fullPath: '/recipes/'
      preLoaderRoute: typeof RecipesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recipes/new': {
      id: '/recipes/new'
      path: '/recipes/new'
      fullPath: '/recipes/new'
      preLoaderRoute: typeof RecipesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/s/$token': {
      id: '/s/$token'
      path: '/s/$token'
      fullPath: '/s/$token'
      preLoaderRoute: typeof STokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support/': {
      id: '/support/'
      path: '/support'
      fullPath: '/support/'
      preLoaderRoute: typeof SupportIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support/$tab': {
      id: '/support/$tab'
      path: '/support/$tab'
      fullPath: '/support/$tab'
      preLoaderRoute: typeof SupportTabRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/t/$token': {
      id: '/t/$token'
      path: '/t/$token'
      fullPath: '/t/$token'
      preLoaderRoute: typeof TTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users/': {
      id: '/admin/users/'
      path: '/users'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AdminUsersIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/users/$userId': {
      id: '/admin/users/$userId'
      path: '/users/$userId'
      fullPath: '/admin/users/$userId'
      preLoaderRoute: typeof AdminUsersUserIdRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/batches/$batchId/': {
      id: '/batches/$batchId/'
      path: '/batches/$batchId'
      fullPath: '/batches/$batchId/'
      preLoaderRoute: typeof BatchesBatchIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/batches/$batchId/brew': {
      id: '/batches/$batchId/brew'
      path: '/batches/$batchId/brew'
      fullPath: '/batches/$batchId/brew'
      preLoaderRoute: typeof BatchesBatchIdBrewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/batches/$batchId/feedback': {
      id: '/batches/$batchId/feedback'
      path: '/batches/$batchId/feedback'
      fullPath: '/batches/$batchId/feedback'
      preLoaderRoute: typeof BatchesBatchIdFeedbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/batches/$batchId/sheet': {
      id: '/batches/$batchId/sheet'
      path: '/batches/$batchId/sheet'
      fullPath: '/batches/$batchId/sheet'
      preLoaderRoute: typeof BatchesBatchIdSheetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blending/$blendId/': {
      id: '/blending/$blendId/'
      path: '/blending/$blendId'
      fullPath: '/blending/$blendId/'
      preLoaderRoute: typeof BlendingBlendIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blending/$blendId/feedback': {
      id: '/blending/$blendId/feedback'
      path: '/blending/$blendId/feedback'
      fullPath: '/blending/$blendId/feedback'
      preLoaderRoute: typeof BlendingBlendIdFeedbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/journals/$journalId/': {
      id: '/journals/$journalId/'
      path: '/journals/$journalId'
      fullPath: '/journals/$journalId/'
      preLoaderRoute: typeof JournalsJournalIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/journals/$journalId/feedback': {
      id: '/journals/$journalId/feedback'
      path: '/journals/$journalId/feedback'
      fullPath: '/journals/$journalId/feedback'
      preLoaderRoute: typeof JournalsJournalIdFeedbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recipes/$recipeId/': {
      id: '/recipes/$recipeId/'
      path: '/recipes/$recipeId'
      fullPath: '/recipes/$recipeId/'
      preLoaderRoute: typeof RecipesRecipeIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recipes/$recipeId/sheet': {
      id: '/recipes/$recipeId/sheet'
      path: '/recipes/$recipeId/sheet'
      fullPath: '/recipes/$recipeId/sheet'
      preLoaderRoute: typeof RecipesRecipeIdSheetRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AdminRouteRouteChildren {
  AdminBillingRoute: typeof AdminBillingRoute
  AdminBoardRoute: typeof AdminBoardRoute
  AdminGalleryRoute: typeof AdminGalleryRoute
  AdminHealthRoute: typeof AdminHealthRoute
  AdminSupportRoute: typeof AdminSupportRoute
  AdminUsageRoute: typeof AdminUsageRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminUsersUserIdRoute: typeof AdminUsersUserIdRoute
  AdminUsersIndexRoute: typeof AdminUsersIndexRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminBillingRoute: AdminBillingRoute,
  AdminBoardRoute: AdminBoardRoute,
  AdminGalleryRoute: AdminGalleryRoute,
  AdminHealthRoute: AdminHealthRoute,
  AdminSupportRoute: AdminSupportRoute,
  AdminUsageRoute: AdminUsageRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminUsersUserIdRoute: AdminUsersUserIdRoute,
  AdminUsersIndexRoute: AdminUsersIndexRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  CalendarRoute: CalendarRoute,
  GalleryRoute: GalleryRoute,
  IngredientsRoute: IngredientsRoute,
  InsightsRoute: InsightsRoute,
  InventoryRoute: InventoryRoute,
  ListingsRoute: ListingsRoute,
  SettingsRoute: SettingsRoute,
  SigninRoute: SigninRoute,
  BatchesLabelsRoute: BatchesLabelsRoute,
  BatchesTastingCardsRoute: BatchesTastingCardsRoute,
  GEntryIdRoute: GEntryIdRoute,
  InviteTokenRoute: InviteTokenRoute,
  JTokenRoute: JTokenRoute,
  ProfilesTabRoute: ProfilesTabRoute,
  RecipesNewRoute: RecipesNewRoute,
  STokenRoute: STokenRoute,
  SupportTabRoute: SupportTabRoute,
  TTokenRoute: TTokenRoute,
  BatchesIndexRoute: BatchesIndexRoute,
  BlendingIndexRoute: BlendingIndexRoute,
  JournalsIndexRoute: JournalsIndexRoute,
  ProfilesIndexRoute: ProfilesIndexRoute,
  RecipesIndexRoute: RecipesIndexRoute,
  SupportIndexRoute: SupportIndexRoute,
  BatchesBatchIdBrewRoute: BatchesBatchIdBrewRoute,
  BatchesBatchIdFeedbackRoute: BatchesBatchIdFeedbackRoute,
  BatchesBatchIdSheetRoute: BatchesBatchIdSheetRoute,
  BlendingBlendIdFeedbackRoute: BlendingBlendIdFeedbackRoute,
  JournalsJournalIdFeedbackRoute: JournalsJournalIdFeedbackRoute,
  RecipesRecipeIdSheetRoute: RecipesRecipeIdSheetRoute,
  BatchesBatchIdIndexRoute: BatchesBatchIdIndexRoute,
  BlendingBlendIdIndexRoute: BlendingBlendIdIndexRoute,
  JournalsJournalIdIndexRoute: JournalsJournalIdIndexRoute,
  RecipesRecipeIdIndexRoute: RecipesRecipeIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
